<template lang="pug">
  div(id="app" data-server-rendered="true")
    //- LiveChatWidget(license="12659496" visibility="hidden" group="0")
    router-view
</template>
<script>
// import { LiveChatWidget } from '@livechat/widget-vue/v2'
export default {
  components: {
    // LiveChatWidget,
  },
  data(){
    return{
      domain0: [
        "https://epic777.com/", 
        "http://epic777.com/",
        "https://www.epic777.com/",
        "http://www.epic777.com/"
      ],
      domain1: [
        "https://epic11.co/", 
        "http://epic11.co/",
        "https://www.epic11.co/",
        "http://www.epic11.co/"
      ],
      domain2: [
        "https://epic11.net/", 
        "http://epic11.net/",
        "https://www.epic11.net/",
        "http://www.epic11.net/"
      ],
      domain3: [
        "https://epicwin8.cc/", 
        "http://epicwin8.cc/",
        "https://www.epicwin8.cc/",
        "http://www.epicwin8.cc/"
      ],
    }
  },
  // metaInfo(){
  //   var site = window.location.protocol + "//" + window.location.hostname + "/";
    
  //   if(this.domain0.includes(site)){
  //     return{
  //       title: "EpicWin | No.1 Online Casino",
  //       meta:[
  //         {vmid: "description",name: 'description', content: "Discover the best gaming experience with EpicWin, the No.1 online casino. Enjoy top-tier games and big wins at EpicWin today! "}
  //       ],
  //     }
  //   }else if(this.domain1.includes(site)){
  //     return{
  //       title: "EpicWin | Top Online Casino Gaming in Malaysia",
  //       meta:[
  //         {vmid: "description",name: 'description', content: "Join EpicWin, your premier destination for online casino gaming. Experience slots, live casino, and more with EpicWin."}
  //       ],
  //     }
  //   }else if(this.domain2.includes(site)){
  //     return{
  //       title: "EpicWin | Best Online Casino Experience",
  //       meta:[
  //         {vmid: "description",name: 'description', content: "Play your favorite online casino games at EpicWin, where excitement meets opportunity. Sign up now and start winning with EpicWin."}
  //       ],
  //     }
  //   }else if(this.domain3.includes(site)){
  //     return{
  //       title: "EpicWin | Ultimate Casino Entertainment",
  //       meta:[
  //         {vmid: "description",name: 'description', content: "EpicWin offers the best online casino. Spin the reels and try your luck with EpicWin's wide range of games, bonus."}
  //       ],
  //     }
  //   }else{
  //     return{
  //       title: "EpicWin | Online Casino Malaysia | Trusted Slot Casino ",
  //       meta:[
  //         {vmid: "description",name: 'description', content: "Get the best online casino Malaysia experience in EpicWin. Play live casino, slot games, fishing games, poker games. Claim free RM10 upon signup."}
  //       ],
  //     }
  //   }
  // },
  // metaInfo: {
  //   title: 'EpicWin | Online Casino Malaysia | Trusted Slot Casino',
  // },
  mounted(){
    // this.$meta().refresh
  }
}
</script>
<style lang="scss">

</style>
